export default "__VITE_ASSET__DuOP$3kA__"